import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const ColonIcon = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-auto',
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      fill={fillColor}
      viewBox='-3.2 -3.2 38.40 38.40'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <g transform='translate(9.591 1.64)'>
        <g
          id='SVGRepo_tracerCarrier'
          strokeLinecap='round'
          strokeLinejoin='round'
          stroke={fillColor}
          strokeWidth='2.2399999999999998'>
          <path d='M8.406 9.688h2.406v2.406h-2.406v-2.406zM8.406 23.031h2.406v2.406h-2.406v-2.406z'></path>
        </g>
        <g id='SVGRepo_iconCarrier'>
          <path d='M8.406 9.688h2.406v2.406h-2.406v-2.406zM8.406 23.031h2.406v2.406h-2.406v-2.406z'></path>
        </g>
      </g>
    </svg>
  );
};

export default ColonIcon;
